<template>
  <div id="search-results" :class="{'search-opened': open}" style="position:fixed;">

    <div id="top-search" class="top-search columns is-light is-border-bottom is-vcentered">
      <div class="column is-narrow has-text-primary is-padding-bottom-small is-padding-top-small">
        <strong v-if="loading">Chargements...</strong>
        <strong v-else>{{totalResults}} résultat(s)</strong>
      </div>
      <div v-for="result in results" class="column is-narrow is-padding-top-small is-padding-bottom-small">
        <div class="field">
          <input class="is-checkradio is-circle" :id="result.key" :value="result.key" type="checkbox"
                 name="displayedCategories"
                 v-model="displayedCategories">
          <label :for="result.key">
            <strong>{{result.key | prettyName}} ({{result.items.length}})</strong>
          </label>
        </div>
      </div>
    </div>

    <div id="content-search">
      <div v-for="result in displayedResults" class="column is-3 is-pulled-left">
        <p class="is-size-6 has-text-primary is-margin-bottom">
          <strong>{{result.key | prettyName}}</strong>
        </p>
        <ul>
          <li v-for="item in result.items">
            <div>
              <span>
                <a @click="showResult(item, result.key)" v-if="autoPathEnabled.includes(result.key)">
                    <strong>{{item | autoName(result.key)}}</strong>
                </a>
                <a @click="showRdvResult(item, result.key)" v-else-if="result.key === 'RDV'">
                  <strong>{{item | autoName(result.key)}}</strong>
                </a>
                <strong v-else>{{item | autoName(result.key)}}</strong>
              </span>
              <span v-if="subtitlesEnabled.includes(result.key)" class="has-text-grey is-size-6">
                {{item | autoSubtitle(result.key)}}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import { bus, EVENTS } from '../../services/bus'
  import { mapState, mapGetters } from 'vuex'
  import moment from 'moment'
  import { debounce } from 'lodash'

  const subtitlesEnabled = ['USER', 'CONTACT', 'PROGRAM', 'LOT']
  const autoPathEnabled = ['USER', 'CONTACT', 'PROGRAM', 'LOT', 'COMPANY', 'PROMOTEUR']

  export default {
    name: 'SearchPanel',
    filters: {
      autoName (item, key) {
        if (key === 'RDV') {
          let rdvType = item.rdv_type
          let contactName = item.contact_name
          let date = item.date
          return `${rdvType} avec ${contactName} le ${date}`
        } else if (key === 'USER' || key === 'CONTACT') {
          return item.first_name + ' ' + item.last_name
        } else {
        }
        return item.name
      },
      prettyName (key) {
        const names = {
          LOT: 'Lots',
          PROGRAM: 'Programmes',
          USER: 'Utilisateurs',
          CONTACT: 'Contacts',
          PROMOTEUR: 'Promoteurs',
          COMPANY: 'Sociétés',
          RDV: 'Rendez-Vous'
        }
        if (key in names) {
          return names[key]
        }
      },
      autoSubtitle (item, key) {
        if (['USER', 'CONTACT'].includes(key)) {
          return item.email
        } else if (['LOT', 'PROGRAM'].includes(key)) {
          return item.address.city + ' ' + item.address.zip_code
        }
      }
    },
    data () {
      return {
        MAX_HITS: 30,
        subtitlesEnabled: subtitlesEnabled,
        autoPathEnabled: autoPathEnabled,
        displayedCategories: [],
        loading: false,
        query: null,
        results: {},
        open: false
      }
    },
    computed: {
      ...mapState([
        'currentUser'
      ]),
      ...mapGetters([
        'currentUserName', 'isLog', 'currentUserPk', 'currentCompanyPk',
        'isSeller', 'isExternal', 'isAdmin', 'isManager', 'isOperator', 'isEditor',
        'isApi', 'isDistributeurMode', 'isSectorManager'
      ]),
      displayedResults () {
        return Object.values(this.results).filter(x => {
          return this.displayedCategories.includes(x.key)
        })
      },
      totalResults () {
        return Object.values(this.results).reduce((a, b) => {
          return a + b.items.length
        }, 0)
      }
    },
    methods: {
      autoPath (item, key) {
        const RouterNames = {
          LOT: 'LotVue',
          PROGRAM: 'ProgramVue',
          USER: 'UserVue',
          CONTACT: 'ContactVue',
          PROMOTEUR: 'PromoteurVue',
          COMPANY: 'CompanyVue'
        }
        if (key in RouterNames) {
          return { name: RouterNames[key], params: { id: item.pk } }
        }
      },
      rdvAutoPath (item) {
        let date = moment(item.date, 'DD/MM/YYYY')
        return {
          name: 'CalendarDayView',
          query: { day: date.format('DD'), month: date.format('MM'), year: date.format('YYYY') }
        }
      },
      showResult (item, key) {
        let path = this.autoPath(item, key)
        this.closeSearchPanel()
        this.$router.push(path)
      },
      showRdvResult (item) {
        let path = this.rdvAutoPath(item)
        this.closeSearchPanel()
        this.$router.push(path)
      },
      initSearchPanel (query) {
        this.query = query
        if (this.query && this.query.length >= 2) {
          this.openSearchPanel()
          this.startAlgoliaSearch()
        } else {
          this.closeSearchPanel()
        }
      },
      startAlgoliaSearch () {
        this.loading = true
        let query = this.query
        let hitsPerPage = this.MAX_HITS
        this.$set(this, 'results', {})
        let queries = []

        let programQuery = {
          indexName: 'PROGRAM',
          query,
          params: {
            hitsPerPage,
            facetFilters: ['status:-archived']
          }
        }
        if (!this.isAdmin) {
          programQuery.params.facetFilters.push('status:-draft')
        }

        if (this.isExternal) {
          programQuery.params.facetFilters.push('accesses:' + this.currentCompanyPk)
        }

        queries.push(programQuery)

        let lotQuery = {
          indexName: 'LOT',
          query,
          params: {
            hitsPerPage,
            facetFilters: ['status:-archived', 'program_status:-archived']
          }
        }
        if (!this.isAdmin) {
          lotQuery.params.facetFilters.push('status:-draft')
          lotQuery.params.facetFilters.push('status:-sold')
          lotQuery.params.facetFilters.push('status:-reserved')
          lotQuery.params.facetFilters.push('program_status:-draft')
        }

        if (this.isExternal) {
          lotQuery.params.facetFilters.push('accesses:' + this.currentCompanyPk)
        }
        queries.push(lotQuery)

        if (!this.isEditor) {
          let contactQuery = {
            indexName: 'CONTACT',
            query,
            params: {
              hitsPerPage,
              facetFilters: ['status:-archived']
            }
          }
          if (this.isSeller) {
            contactQuery.params.facetFilters.push('seller:' + this.currentUserPk)
          }

          if (this.isSectorManager) {
            contactQuery.params.facetFilters.push('accesses:' + this.currentUserPk)
          }

          if (this.isExternal) {
            contactQuery.params.facetFilters.push('company:' + this.currentCompanyPk)
          }
          queries.push(contactQuery)
        }

        if (this.isAdmin || this.isSectorManager || this.isManager || this.isOperator) {
          let userQuery = {
            indexName: 'USER',
            query,
            params: {
              hitsPerPage,
              facetFilters: []
            }
          }
          if (this.isSectorManager) {
            userQuery.params.facetFilters.push('accesses:' + this.currentUserPk)
          }
          if (this.isExternal) {
            userQuery.params.facetFilters.push('company:' + this.currentCompanyPk)
          }
          if (this.isManager) {
            userQuery.params.facetFilters.push('manager:' + this.currentUserPk)
          }
          queries.push(userQuery)
        }

        if (!this.isExternal) {
          let rdvQuery = {
            indexName: 'RDV',
            query,
            params: {
              hitsPerPage,
              facetFilters: []
            }
          }

          if (!this.isAdmin) {
            rdvQuery.params.facetFilters.push('accesses:' + this.currentUserPk)
          }

          queries.push(rdvQuery)
        }

        if (this.isDistributeurMode && (this.isAdmin || this.isEditor)) {
          let promoteurQuery = {
            indexName: 'PROMOTEUR',
            query,
            params: {
              hitsPerPage,
              facetFilters: []
            }
          }
          queries.push(promoteurQuery)
        }

        if (this.isAdmin || this.isSectorManager) {
          let companyQuery = {
            indexName: 'COMPANY',
            query,
            params: {
              hitsPerPage,
              facetFilters: []
            }
          }
          if (this.isSectorManager) {
            companyQuery.params.facetFilters.push('accesses:' + this.currentUserPk)
          }
          queries.push(companyQuery)
        }

        this.$algolia.search(queries, (err, res) => {
          if (err) {
            this.loading = false
          } else {
            res.results.forEach(x => {
              let key = x.index
              if (x.hits && x.hits.length > 0) {
                this.$set(this.results, key, {
                  items: x.hits,
                  key: key
                })
                if (!this.displayedCategories.includes(key)) {
                  this.displayedCategories.push(key)
                }
              }
            })
            this.loading = false
          }
        })
      },
      openSearchPanel () {
        this.open = true
      },
      closeSearchPanel () {
        this.open = false
        this.resetSearchPanel()
      },
      resetSearchPanel () {
        this.loading = false
        this.query = null
        this.results = {}
      }
    },
    mounted () {
      bus.$on(EVENTS.INIT_SEARCH_PANEL, debounce(this.initSearchPanel, 400))
      bus.$on(EVENTS.OPEN_SEARCH_PANEL, this.openSearchPanel)
      bus.$on(EVENTS.CLOSE_SEARCH_PANEL, this.closeSearchPanel)
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/layout/SearchPanel.vue